import { Button, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";

function CreateTableBtn({ route }) {
  const {
    t,
  } = useTranslation();

  const history = useHistory();

  return (
    <Col>
      <div style={{ textAlign: "end" }}>
        <Button
          className="btn-wd btn-outline mr-1"
          variant="success"
          onClick={() => {
            history.push(route);
          }}
        >
          <i className="fa fa-plus" />{t("common.actions.create")}</Button>
      </div>
    </Col>
  );
}

export default CreateTableBtn;
